import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Search, Check, Wand2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const B = process.env.REACT_APP_BACKEND_URL;

const Pick = ({ url, on, toggle, testId }) => (
  <button data-testid={testId} onClick={toggle} className={`relative aspect-square overflow-hidden rounded-lg border-2 bg-white ${on ? "border-amber-400" : "border-transparent"}`}>
    <img src={url.includes("/api/public/creatives/") ? `${url}?w=240` : url} alt="" className="h-full w-full object-contain" loading="lazy" />
    {on && <span className="absolute right-1 top-1 rounded-full bg-amber-400 p-0.5 text-zinc-950"><Check className="h-3 w-3" /></span>}
  </button>
);

export const NewLandingDialog = ({ onClose, onCreated }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [prod, setProd] = useState(null);
  const [angle, setAngle] = useState("");
  const [imgs, setImgs] = useState([]);
  const [creatives, setCreatives] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => axios.get(`${B}/api/creatives/products`, { params: { q } }).then((r) => setResults(r.data.items || [])).catch(() => {}), 300);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => { axios.get(`${B}/api/creatives`, { params: { kind: "image" } }).then((r) => setCreatives(r.data.items || [])).catch(() => {}); }, []);
  const choose = (p) => { setProd(p); setImgs(p.images.slice(0, 4)); };
  const toggle = (u) => setImgs((s) => (s.includes(u) ? s.filter((x) => x !== u) : s.length >= 8 ? s : [...s, u]));
  const mine = creatives.filter((c) => c.sku === prod?.sku);

  const go = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${B}/api/landing`, { sku: prod.sku, angle, images: imgs }, { timeout: 180000 });
      toast.success("Pagina e scrisă — verific-o și corecteaz-o"); onCreated(r.data); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="new-landing-dialog" className="block max-h-[90vh] max-w-2xl space-y-3 overflow-y-auto">
        <DialogHeader><DialogTitle>Landing page nou</DialogTitle></DialogHeader>
        <div className="relative">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-zinc-500" />
          <Input data-testid="lp-product-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Caută produs după nume sau SKU" className="pl-9" />
        </div>
        <div className="flex h-28 shrink-0 flex-wrap content-start gap-2 overflow-y-auto">
          {results.map((p) => (
            <button key={p.sku} data-testid={`lp-product-${p.sku}`} onClick={() => choose(p)} className={`rounded-full border px-3 py-1 text-xs ${prod?.sku === p.sku ? "border-amber-500 bg-amber-400 text-zinc-950" : "border-zinc-300 text-zinc-700 hover:border-zinc-500"}`}>{p.sku} · {p.title.slice(0, 40)}</button>
          ))}
        </div>
        {prod && (
          <>
            <p className="text-xs text-zinc-600">Imagini ({imgs.length}/8, prima e imaginea principală) — din Shopify{mine.length ? " și din Creative Ads" : ""}</p>
            <div className="grid grid-cols-6 gap-2">
              {prod.images.map((u, i) => <Pick key={u} url={u} on={imgs.includes(u)} toggle={() => toggle(u)} testId={`lp-img-shop-${i}`} />)}
              {mine.map((c) => <Pick key={c.id} url={c.url} on={imgs.includes(c.url)} toggle={() => toggle(c.url)} testId={`lp-img-cr-${c.id}`} />)}
            </div>
            <Textarea data-testid="lp-angle-input" value={angle} onChange={(e) => setAngle(e.target.value)} rows={2}
              placeholder="Unghi / public (opțional): ex. pentru mame ocupate, ofertă Black Friday, cadou de Crăciun" />
          </>
        )}
        <button data-testid="lp-create-btn" onClick={go} disabled={!prod || busy || !imgs.length} className="flex w-full items-center justify-center gap-2 rounded-full bg-amber-400 py-2.5 text-sm font-semibold text-zinc-950 disabled:opacity-50">
          {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> AI-ul scrie pagina (~30–60 s)…</> : <><Wand2 className="h-4 w-4" /> Scrie pagina cu AI</>}
        </button>
      </DialogContent>
    </Dialog>
  );
};
